import { Component, Inject, OnInit } from '@angular/core'
import { UserContextStorageService } from '../auth/user-context/user-context-storage.service'

/**
 * LayoutComponent - Main layout wrapper for authenticated routes
 * Based on reference project: ca-assets-frontend-ng14/src/app/core/layout/layout.component.ts
 *
 * Contains:
 * - Loading bar
 * - Header component
 * - Main content area with nested router-outlet
 * - Blocked user message (if applicable)
 *
 * This component is used as a parent for all authenticated routes,
 * ensuring consistent layout without duplicating header/nav across pages.
 */
@Component({
    selector: 'ca-layout',
    templateUrl: './layout.component.html',
    standalone: false
})
export class LayoutComponent implements OnInit {

    blockedUser = false

    constructor(
        @Inject(UserContextStorageService) private userContextStorageService: UserContextStorageService
    ) {}

    ngOnInit(): void {
        // Check if user is blocked (unpaid service)
        if (this.userContextStorageService.getProject()?.blockUsers === true) {
            if (!this.userContextStorageService.getUser()?.adminPermission) {
                this.blockedUser = true
            }
        }
    }
}
